module.exports = __webpack_public_path__ + "img/testimonial_3.91c7b06a.png";